export const depositModalTranslations = {
  ru: {
    paymentMethods: {
      easydonateDesc: "Только для РФ",
      tebexDesc: "Весь мир (кроме РФ), PayPal",
      paypalDesc: "Весь мир (кроме РФ)",
      lavaDesc: "Весь мир"
    },
    states: {
      waitingTitle: "Ожидаем оплату",
      waitingDesc: "Пожалуйста, завершите платеж в новой вкладке. Мы автоматически проверим статус.",
      cancelBtn: "Отмена",
      successTitle: "Оплата прошла!",
      successDesc: "Баланс успешно пополнен.",
      creatingPayment: "Создание платежа..."
    },
    header: {
      titleDeposit: "Пополнение",
      titleMethod: "Способ оплаты",
      balance: "Баланс:",
      needMore: "Нужно еще:"
    },
    form: {
      crystals: "Кристаллы",
      payBtn: "Оплатить",
      hideMethods: "Скрыть",
      showAllMethods: "Показать все способы"
    },
    footer: {
      secure: "Официальный магазин • SSL Protection"
    },
    errors: {
      initError: "Ошибка при инициализации платежа",
      defaultError: "Произошла ошибка, попробуйте позже."
    }
  },
  en: {
    paymentMethods: {
      easydonateDesc: "Russia only",
      tebexDesc: "Worldwide, PayPal",
      paypalDesc: "Worldwide",
      lavaDesc: "Worldwide"
    },
    states: {
      waitingTitle: "Waiting for payment",
      waitingDesc: "Please complete the payment in the new tab. We will automatically check the status.",
      cancelBtn: "Cancel",
      successTitle: "Payment successful!",
      successDesc: "Balance successfully replenished.",
      creatingPayment: "Creating payment..."
    },
    header: {
      titleDeposit: "Deposit",
      titleMethod: "Payment Method",
      balance: "Balance:",
      needMore: "Need more:"
    },
    form: {
      crystals: "Crystals",
      payBtn: "Pay",
      hideMethods: "Hide",
      showAllMethods: "Show all methods"
    },
    footer: {
      secure: "Official Store • SSL Protection"
    },
    errors: {
      initError: "Error initializing payment",
      defaultError: "An error occurred, please try again later."
    }
  }
};